import { render, staticRenderFns } from "./TeaserProperty.vue?vue&type=template&id=21b88e34&scoped=true&lang=pug&"
import script from "./TeaserProperty.vue?vue&type=script&lang=js&"
export * from "./TeaserProperty.vue?vue&type=script&lang=js&"
import style0 from "./TeaserProperty.vue?vue&type=style&index=0&id=21b88e34&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b88e34",
  null
  
)

export default component.exports